import React from 'react';
import MarkdownDocPage from '../MarkdownDocPage';

export default function UserManualSetupPage() {
    return <MarkdownDocPage title="Setup" markdownUrl="/docs/user-manual/pages/setup.md" />;
}

